import { useEffect, useState } from 'react';

// Retourne une valeur "debounced" : ne change qu'après que `delay` ms se soient écoulés
// sans nouvelle modification. Idéal pour les champs de recherche déclenchant un appel API.
const useDebounce = (value, delay = 400) => {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => setDebouncedValue(value), delay);
        return () => clearTimeout(handler);
    }, [value, delay]);

    return debouncedValue;
};

export default useDebounce;
